// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__KjdN6","buttons":"Footer_buttons__1CE57"};